/**
 * @file API service — rawMaterialQualityAttributesPublicService.
 * GET /raw-material-quality-attributes?materialId= — public, no auth.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";
import type { RawMaterialQualityAttributeOption } from "../interfaces/formInterfaces";

/** Exported function — fetch Raw Material Quality Attributes. */
export async function fetchRawMaterialQualityAttributes(
  materialId: number
): Promise<RawMaterialQualityAttributeOption[]> {
  if (!Number.isFinite(materialId) || materialId <= 0) return [];

  try {
    const res = await axiosClient.get(API_URLS.RAW_MATERIAL_QUALITY_ATTRIBUTES, {
      params: { materialId },
    });
    const attrs = res?.data?.data?.attributes;
    if (!Array.isArray(attrs)) return [];

    return attrs
      .map((row: Record<string, unknown>) => ({
        id: Number(row.id),
        attributeKey: String(row.attributeKey ?? "").trim(),
        label: String(row.label ?? "").trim(),
        sortOrder: Number(row.sortOrder) || 0,
      }))
      .filter(
        (a) =>
          Number.isFinite(a.id) &&
          a.id > 0 &&
          a.attributeKey &&
          a.label
      )
      .sort((a, b) => a.sortOrder - b.sortOrder);
  } catch {
    return [];
  }
}
